<template>
    <div class="h-100">
        <header class="d-flex align-items-center mb-5">
            <h5>Transaction Capping</h5>
            <b-btn variant="ghost ml-2 p-0" v-b-popover.hover="'For security purposes, mechanics can only be updated ONCE every 6  months. If you wish to update under the lock in period, please send us a message at support@rush.ph'">
                <i class="ic-tooltip"></i>
            </b-btn>
        </header>
        <div class="modal-form mt-3">
            <b-form>
                <b-row>
                    <b-col sm="12" md="2" class="d-flex">
                        <h6 class="main-label">Earn</h6>
                        <b-btn variant="ghost" class="p-0 align-self-start ml-2 position-relative ghost-tooltip d-none" v-b-popover.hover="'Lorem ipsum dolor sit amet'" title="">
                            <i class="ic-tooltip"></i>
                        </b-btn>
                    </b-col>
                    <b-col sm="12" md="7">
                        <div v-for="(values, index) in form.earn"
                            :key="index"
                            class="d-flex w-100 align-items-center mb-4">
                            <div class="flex-grow-1">
                                <LimitFrequency
                                :form="form"
                                :frequency="frequency.earn"
                                :index="index"
                                :values="values"
                                :key="index"
                                :type="'earn'"
                                :method="values.id == null ? 'add' : 'update'"
                                :addIndex="add_values" />
                            </div>
                            <template v-if="index === 0 && lock === false">
                                <b-btn
                                    variant="add-plus"
                                    class="bg-transparent p-0 shadow-none mt-4 ml-3"
                                    :disabled="form.earn.length > 2"
                                    @click="addRow({
                                        type: 'earn',
                                        index: form.earn.length - 1
                                    })">
                                </b-btn>
                            </template>
                            <template v-if="index > 0">
                                <b-btn
                                    variant="delete"
                                    class="bg-transparent p-0 shadow-none ml-3 align-self-start"
                                    @click="removeRow({
                                        type: 'earn',
                                        index: index,
                                        id: values.id
                                    })">
                                </b-btn>
                            </template>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="9" class="my-3"><hr></b-col>
                </b-row>
                <b-row>
                    <b-col sm="12" md="2" class="d-flex">
                        <h6 class="main-label">Redemption</h6>
                        <b-btn variant="ghost" class="p-0 align-self-start ml-2 position-relative ghost-tooltip d-none" v-b-popover.hover="'Lorem ipsum dolor sit amet'" title="">
                            <i class="ic-tooltip"></i>
                        </b-btn>
                    </b-col>
                    <b-col sm="12" md="7">
                        <div v-for="(values, index) in form.redeem"
                            :key="index"
                            class="d-flex w-100 align-items-center mb-4">
                            <div class="flex-grow-1">
                                <LimitFrequency
                                :form="form"
                                :frequency="frequency.redeem"
                                :index="index"
                                :values="values"
                                :key="index"
                                :type="'redeem'"
                                :method="values.id == null ? 'add' : 'update'"
                                :addIndex="add_values" />
                            </div>
                            <template v-if="index === 0 && lock === false">
                                <b-btn
                                    variant="add-plus"
                                    class="bg-transparent p-0 shadow-none mt-4 ml-3"
                                    :disabled="form.redeem.length > 2"
                                    @click="addRow({
                                        type: 'redeem',
                                        index: form.redeem.length - 1
                                    })">
                                </b-btn>
                            </template>
                            <template v-if="index > 0">
                                <b-btn
                                    variant="delete"
                                    class="bg-transparent p-0 shadow-none ml-3 align-self-start"
                                    @click="removeRow({
                                        type: 'redeem',
                                        index: index,
                                        id: values.id
                                    })">
                                </b-btn>
                            </template>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="9" class="my-3"><hr></b-col>
                </b-row>
                <b-row>
                    <b-col sm="12" md="2" class="d-flex">
                        <h6 class="main-label">Paypoint</h6>
                        <b-btn variant="ghost" class="p-0 align-self-start ml-2 position-relative ghost-tooltip d-none" v-b-popover.hover="'Lorem ipsum dolor sit amet'" title="">
                            <i class="ic-tooltip"></i>
                        </b-btn>
                    </b-col>
                    <b-col sm="12" md="7">
                        <div v-for="(values, index) in form.pay"
                            :key="index"
                            class="d-flex w-100 align-items-center mb-4">
                            <div class="flex-grow-1">
                                <LimitFrequency
                                :form="form"
                                :frequency="frequency.pay"
                                :index="index"
                                :values="values"
                                :key="index"
                                :type="'pay'"
                                :method="values.id == null ? 'add' : 'update'"
                                :addIndex="add_values" />
                            </div>
                            <template v-if="index === 0 && lock === false">
                                <b-btn
                                    variant="add-plus"
                                    class="bg-transparent p-0 shadow-none mt-4 ml-3"
                                    :disabled="form.pay.length > 2"
                                    @click="addRow({
                                        type: 'pay',
                                        index: form.pay.length - 1
                                    })">
                                </b-btn>
                            </template>
                            <template v-if="index > 0">
                                <b-btn
                                    variant="delete"
                                    class="bg-transparent p-0 shadow-none ml-3 align-self-start"
                                    @click="removeRow({
                                        type: 'pay',
                                        index: index,
                                        id: values.id
                                    })">
                                </b-btn>
                            </template>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="9" class="my-3"><hr></b-col>
                </b-row>
                <b-row>
                    <b-col sm="12" md="2" class="d-flex">
                        <h6 class="main-label">Transfer Points</h6>
                        <b-btn variant="ghost" class="p-0 align-self-start ml-2 position-relative ghost-tooltip d-none" v-b-popover.hover="'Lorem ipsum dolor sit amet'" title="">
                            <i class="ic-tooltip"></i>
                        </b-btn>
                    </b-col>
                    <b-col sm="12" md="7">
                        <div v-for="(values, index) in form.transfer"
                            :key="index"
                            class="d-flex w-100 align-items-center mb-4">
                            <div class="flex-grow-1">
                                <LimitFrequency
                                :form="form"
                                :frequency="frequency.transfer"
                                :index="index"
                                :values="values"
                                :key="index"
                                :type="'transfer'"
                                :method="values.id == null ? 'add' : 'update'"
                                :addIndex="add_values" />
                            </div>
                            <template v-if="index === 0 && lock === false">
                                <b-btn
                                    variant="add-plus"
                                    class="bg-transparent p-0 shadow-none mt-4 ml-3"
                                    :disabled="form.transfer.length > 2"
                                    @click="addRow({
                                        type: 'transfer',
                                        index: form.transfer.length - 1
                                    })">
                                </b-btn>
                            </template>
                            <template v-if="index > 0">
                                <b-btn
                                    variant="delete"
                                    class="bg-transparent p-0 shadow-none ml-3 align-self-start"
                                    @click="removeRow({
                                        type: 'transfer',
                                        index: index,
                                        id: values.id
                                    })">
                                </b-btn>
                            </template>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12" md="2" class="mt-5">
                        <b-button :disabled="saving || lock" size="lg" variant="primary" class="save-button btn-block" @click="saveTransactionCapping">
                            {{ this.saving ? "Saving..." : "Save"}}
                        </b-button>
                    </b-col>
                    <b-col md="12" class="mt-2" v-if="lock">
                        <small class="text-danger"><em>For security purposes, mechanics can only be updated ONCE every 6 months. If you wish to update under the lock in period, please send us a message at support@rush.ph</em></small>
                    </b-col>
                </b-row>
            </b-form>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

import LimitFrequency from "./LimitFrequency";

export default {
    name: "TransactionCapping",
    data() {
        return {
            saving: false,
            frequency: {
                earn: [
                    { value: null, text: "Select Frequency", disabled: true },
                    { value: "daily", text: "Daily" },
                    { value: "weekly", text: "Weekly" },
                    { value: "monthly", text: "Monthly" }
                ],
                redeem: [
                    { value: null, text: "Select Frequency", disabled: true },
                    { value: "daily", text: "Daily" },
                    { value: "weekly", text: "Weekly" },
                    { value: "monthly", text: "Monthly" }
                ],
                pay: [
                    { value: null, text: "Select Frequency", disabled: true },
                    { value: "daily", text: "Daily" },
                    { value: "weekly", text: "Weekly" },
                    { value: "monthly", text: "Monthly" }
                ],
                transfer: [
                    { value: null, text: "Select Frequency", disabled: true },
                    { value: "daily", text: "Daily" },
                    { value: "weekly", text: "Weekly" },
                    { value: "monthly", text: "Monthly" }
                ],
            },
            form: {
                earn: [
                    { limit: 0, frequency: null }
                ],
                redeem: [
                    { limit: 0, frequency: null }
                ],
                pay: [
                    { limit: 0, frequency: null }
                ],
                transfer: [
                    { limit: 0, frequency: null }
                ]
            },
            row_type: null,
            add_values: {}
        };
    },
    components: {
        LimitFrequency
    },
    computed: {
        ...mapState("mechanicsCapping", [
            "loading",
            "capping_header_id",
            "transaction_capping",
            "reload",
            "remove_frequency_index",
            "lock"
        ])
    },
    created: function() {
        this.getTransactionCapping();
    },
    methods: {
        addRow: async function(row) {
            let last_item = this.form[row.type].map((item) => {
                return {
                    frequency: item.frequency,
                    limit: item.limit,
                    id: null,
                    capping_header_id: null,
                    transaction_type: row.type
                };
            });

            if (last_item[row.index].frequency !== null) {

                let frequency = last_item[row.index].frequency;
                let frequency_index = this.frequency[row.type].filter((freq) => {
                    return freq.value === frequency;
                });

                // await this.chunkFrequency(frequency_index, row.type);

                this.form[row.type].push({
                    limit: 0,
                    frequency: null,
                    capping_header_id: this.capping_header_id,
                    transaction_type: row.type,
                    id: null
                });
            }
        },

        chunkFrequency: async function(frequency, type) {
            let _frequency = frequency[0];

            let index = this.frequency[type].indexOf(_frequency);

            let transformed_frequency = {
                value: _frequency.value,
                text: _frequency.text,
                disabled: true
            }

            await this.frequency[type].splice(index, 1, transformed_frequency);
        },

        removeRow: function(row) {
            this.$store.commit("mechanicsCapping/errors", null);
            this.$store.commit("mechanicsCapping/setModal", {
                type: "remove_frequency",
                status: true,
                id: row.id,
                index: row.index
            });

            this.row_type = row.type;
        },

        saveTransactionCapping: function() {
            let update_values = {};

            let add_earn = this.form.earn.map(earn => {
                return earn;
            }).filter(earn => earn.id == null);

            this.add_values["earn"] = add_earn;

            let add_redeem = this.form.redeem.map(redeem => {
                return redeem;
            }).filter(redeem => redeem.id == null);

            this.add_values["redeem"] = add_redeem;

            let add_pay = this.form.pay.map(pay => {
                return pay;
            }).filter(pay => pay.id == null);

            this.add_values["pay"] = add_pay;

            let add_transfer = this.form.transfer.map(transfer => {
                return transfer;
            }).filter(transfer => transfer.id == null);

            this.add_values["transfer"] = add_transfer;

            let update_earn = this.form.earn.map(earn => {
                return {
                    id: earn.id,
                    limit: earn.limit,
                    frequency: earn.frequency
                };
            }).filter(earn => earn.id != null);

            update_values["earn"] = update_earn;

            let update_redeem = this.form.redeem.map(redeem => {
                return {
                    id: redeem.id,
                    limit: redeem.limit,
                    frequency: redeem.frequency
                };
            }).filter(redeem => redeem.id != null);

            update_values["redeem"] = update_redeem;

            let update_pay = this.form.pay.map(pay => {
                return {
                    id: pay.id,
                    limit: pay.limit,
                    frequency: pay.frequency
                }
            }).filter(pay => pay.id != null);

            update_values["pay"] = update_pay;

            let update_transfer = this.form.transfer.map(transfer => {
                return {
                    id: transfer.id,
                    limit: transfer.limit,
                    frequency: transfer.frequency
                }
            }).filter(transfer => transfer.id != null);

            update_values["transfer"] = update_transfer;

            this.$store.commit("mechanicsCapping/setAdd", {
                type: "transaction",
                values: this.add_values
            });
            this.$store.commit("mechanicsCapping/setUpdate", {
                type: "transaction",
                values: update_values
            });

            this.$store.commit("mechanicsCapping/setModal", {
                status: true,
                type: "save",
                sub_type: "transaction"
            });
        },

        getTransactionCapping: async function() {
            await this.$store.dispatch("mechanicsCapping/getTransactionCapping")
                .then(() => {
                    this.form.earn = this.transaction_capping.earn;
                    this.form.redeem = this.transaction_capping.redeem;
                    this.form.pay = this.transaction_capping.pay;
                    this.form.transfer = this.transaction_capping.transfer;
                });
        }
    },
    watch: {
        remove_frequency_index: function(value) {
            if (value != null) {
                this.form[this.row_type].splice(value, 1);
                this.$store.commit("mechanicsCapping/setDelete", {
                    id: null,
                    index: null
                });
                this.$store.commit("mechanicsCapping/errors", null);
            }
        },

        reload: async function(value) {
            if (value == true) {
                await this.getTransactionCapping()
                    .then(() => {
                        this.$store.commit("mechanicsCapping/setReload", false);
                    });
            }
        }
    }
};
</script>
